import { render, staticRenderFns } from "./periods.vue?vue&type=template&id=092b3658"
import script from "./periods.vue?vue&type=script&lang=js"
export * from "./periods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports